
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredity/whitelable",
      function () {
        return require("private-next-pages/kredity/whitelable.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredity/whitelable"])
      });
    }
  